import { useState,useEffect } from "react";
import axios from "axios";

function EditManager({manager,onClose}){

const [username,setUsername]=useState(
manager.username
);

const [email,setEmail]=useState(
manager.email
);

const [employeeCode,setEmployeeCode]=useState(
manager.employee_code
);

const [mobile,setMobile]=useState(
manager.mobile
);

const [departmentId,setDepartmentId]=useState(
manager.department_id || ""
);

const [designationId,setDesignationId]=useState(
manager.designation_id || ""
);

const [departments,setDepartments]=useState([]);
const [designations,setDesignations]=useState([]);

useEffect(()=>{

loadDepartments();
loadDesignations();

},[]);

const loadDepartments=async()=>{

try{

const token=
localStorage.getItem(
"token"
);

const response=
await axios.get(

"https://saleupcall.com/api/Department/get-departments.php",

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

setDepartments(
response.data.data
);

}

}
catch(error){

console.log(error);

}

};

const loadDesignations=async()=>{

try{

const token=
localStorage.getItem(
"token"
);

const response=
await axios.get(

"https://saleupcall.com/api/Designation/get-designations.php",

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

setDesignations(
response.data.data
);

}

}
catch(error){

console.log(error);

}

};

const updateManager=async(e)=>{

e.preventDefault();

try{

const token=
localStorage.getItem("token");

const response=await axios.post(

"https://saleupcall.com/api/Manager/edit-manager.php",

{

id:manager.id,

username,
email,

employee_code:employeeCode,
mobile,
department_id:departmentId,
designation_id:designationId

},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert(
"Manager Updated"
);

onClose();

}
else{

alert(
response.data.message
);

}

}
catch(error){

console.log(error);

}

};

return(

<form onSubmit={updateManager}>

<div className="row">

<div className="col-md-6 mb-2">

<input
className="form-control form-control-sm"
placeholder="Username"
value={username}
onChange={(e)=>
setUsername(
e.target.value
)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
className="form-control form-control-sm"
placeholder="Email"
value={email}
onChange={(e)=>
setEmail(
e.target.value
)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
className="form-control form-control-sm"
placeholder="Employee Code"
value={employeeCode}
onChange={(e)=>
setEmployeeCode(
e.target.value
)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
className="form-control form-control-sm"
placeholder="Mobile"
value={mobile}
onChange={(e)=>
setMobile(
e.target.value
)
}
/>

</div>

<div className="col-md-6 mb-2">

<select
className="form-select form-select-sm"
value={departmentId}
onChange={(e)=>
setDepartmentId(
e.target.value
)
}
>

<option value="">

Select Department

</option>

{
departments.map(
(item)=>(

<option
key={item.id}
value={item.id}
>

{item.department_name}

</option>

)
)
}

</select>

</div>

<div className="col-md-6 mb-2">

<select
className="form-select form-select-sm"
value={designationId}
onChange={(e)=>
setDesignationId(
e.target.value
)
}
>

<option value="">

Select Designation

</option>

{
designations.map(
(item)=>(

<option
key={item.id}
value={item.id}
>

{item.designation_name}

</option>

)
)
}

</select>

</div>

</div>

<div className="text-end mt-2">

<button
className="btn btn-primary btn-sm"
>

<i className="bi bi-check-lg me-1"></i>

Update

</button>

</div>

</form>

);

}

export default EditManager;